<template>
    <v-menu
        left
        bottom
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on"
            >
                <country-flag :country="countries[currentLocale]" size='normal'/>
            </v-btn>
        </template>

        <v-list dense>
            <v-list-item
                v-for="locale in locales"
                :key="locale"
                @click="setLocale(locale)"
            >
                <v-list-item-icon>
                    <country-flag :country="countries[locale]" size='normal'/>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="text-uppercase" v-text="locale"></v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import CountryFlag from 'vue-country-flag'
import { Locale } from "../../modules/utils";

export default {
    name: "LocaleSelect",
    components: {
        CountryFlag,
    },
    data () {
        return {
            locales: [
                'pl',
                'en',
            ],
            countries: {
                'pl': 'pl',
                'en': 'gb',
            },
        };
    },
    computed: {
        currentLocale: function () {
            return this.$i18n.locale;
        },
    },
    methods: {
        setLocale: function(locale) {
            this.$i18n.locale = locale;
        }
    },
    created() {
        Locale.setCurrencyNumberFormat(this.$i18n.locale);
        Locale.setDateTimeFormat(this.$i18n.locale);
    },
    watch: {
        currentLocale: function (currentLocale) {
            Locale.saveToCookie(currentLocale);

            Locale.setCurrencyNumberFormat(currentLocale);
            Locale.setDateTimeFormat(currentLocale);
        }
    },
}
</script>

<style scoped>

</style>
